import Component from '@cell/cell-core/component/component';
import { formatLocalizedPrice } from '../../scripts/utils/format-price';
import './price-list.scss';

class PriceList extends Component {
  constructor() {
    super();
  }

  componentDidMount() {}

  setCompareAtPrice(price) {
    if (!this.compareAtPriceElement) return;

    this.compareAtPriceElement.textContent = formatLocalizedPrice(price);
  }

  setPrice(price) {
    if (!this.priceElement) return;

    this.priceElement.textContent = formatLocalizedPrice(price);
  }

  hideCompareAtPrice() {
    this.compareAtPriceElement.classList.add('u-Hidden');
  }

  showCompareAtPrice() {
    this.compareAtPriceElement.classList.remove('u-Hidden');
  }

  get compareAtPriceElement() {
    return this.querySelector('.CompareAtPrice');
  }

  get priceElement() {
    return this.querySelector('.Price');
  }
}

customElements.define('price-list', PriceList);
